import React from 'react';
import styled from 'styled-components';
import breakpoints from '../../vars/breakpoints';
import gutters from '../../vars/gutters';
import colors from '../../vars/colors';

export const FooterWrapper = styled.div`
    margin-top: 120px;
    width: 100%;
    background: ${colors['white-two']};
    @media (max-width: ${breakpoints['bp-mobile']}) {
        padding: 20px 0 0;
    }
    > div {
        overflow: auto;
    }
    .footerContent {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        padding-top: 20px;
        @media (max-width: ${breakpoints['bp-mobile']}) {
            justify-content: center;
            align-items: center;
        }
    }
    .langColumn {
        @media (max-width: ${breakpoints['bp-mobile']}) {
            margin-bottom: 20px;
        }
        p {
            font-size: 12px;
        }
        button {
            background-color: transparent;
            border: none;
            color: ${colors['lipstick']};
            margin-right: 16px;
            outline: none;
            padding: 0;

            &:hover,
            &:focus {
                text-decoration: underline;
            }
        }
    }
    .copyright {
        font-family: 'OneDot';
        font-size: 10px;
        font-weight: bold;
        color: ${colors['lipstick']};
        line-height: 1.2;
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        .footerContent {
            .logoColumn {
                order: 2;
            }
            .copyrightColumn {
                order: 1;
            }
        }
    }
`;


// WEBPACK FOOTER //
// ./src/components/footer/styled-components.js